// Format number with commas (e.g., 1,000,000)
export const formatNumber = (num) => {
  if (num === null || num === undefined || num === "") return "0";
  return Number(num).toLocaleString('en-US');
};

// Calculate age from date of birth
export const calculateAge = (dob) => {
  if (!dob) return null;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Format date to Arabic with English numerals
export const formatDateArabic = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
};

// Format full datetime with seconds using English numerals (e.g., 26/04/2026 14:30:45)
export const formatFullDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { 
    year: "numeric", month: "2-digit", day: "2-digit", 
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false
  });
};

// Format date and time (without seconds) using English numerals
export const formatDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { 
    year: "numeric", month: "2-digit", day: "2-digit", 
    hour: "2-digit", minute: "2-digit",
    hour12: false
  });
};
